// extracted by mini-css-extract-plugin
export default {"book-added-container":"SuccessModal_book-added-container__B4Bcm","link-back-button":"SuccessModal_link-back-button__a5th9"};